import { createSlice } from '@reduxjs/toolkit'

const SLICE_KEY = 'settings'

export const initialState = {
  isModalDisplayed: false,
}

const slice = createSlice({
  name: SLICE_KEY,
  initialState,
  reducers: {
    setModalDisplayed(state, { payload = {} }) {
      const { isDisplayed = false } = payload
      state.isModalDisplayed = isDisplayed
    },
  },
})

export const { setModalDisplayed } = slice.actions

export const settingsReducer = slice.reducer
